import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useEffect, useState, useMemo } from "react";
import { AmountFormatCell } from "components/common/formatter";
import { NumericCell } from "../DibursementPayment/DisbursementInputField";
import { DateFormatCell } from "components/common/formatter";
import { process } from "@progress/kendo-data-query";
const initialDataState = {
  sort: [{ field: "date", dir: "asc" }],
  take: 50,
  skip: 0,
};
const OfficeCreditGrid = (props) => {
  const [dataState, setDataState] = useState(initialDataState);
  const [data, setData] = useState([]);

  const matters = useMemo(() => {
    if (props.officeCreditList && props.officeCreditList.length > 0) {
      return props.officeCreditList.map((item) => ({
        ...item,
        inEdit: true,
        add: false,
        amount: 0,
      }));
    }
    return ["LIST_EMPTY"];
  }, [props.officeCreditList]);
  const amount = props.Amount || 0;
  const dataStateChange = (e) => {
    if (
      e.dataState.sort !== undefined &&
      e.dataState.skip !== 0 &&
      dataState.sort !== e.dataState.sort
    ) {
      setDataState({ ...e.dataState, skip: 0 });
    } else if (e.dataState.sort[0] === undefined) {
      setDataState({
        ...e.dataState,
        sort: [
          {
            field: dataState.sort[0].field,
            dir: "asc",
          },
        ],
      });
    } else {
      setDataState(e.dataState);
    }
  };

  useEffect(() => {
    if (matters[0] === "LIST_EMPTY") {
      setData([]);
    } else if (!data.length) {
      setData(matters);
    }
  }, [matters]);

  const mergeAllocation = () => {
    const result = data
      .filter((item) => item.add)
      .map((item) => ({
        postingId: item.postingId,
        amount: item.amount,
      }));
    if (props.updateAllocations) {
      props.updateAllocations(result);
    }
  };

  const totalAllocatingAmount = useMemo(() => {
    return data.reduce((total, item) => {
      if (item.add === true && item.amount !== null && item.amount !== undefined) {
        return total + parseFloat(item.amount || 0);
      }
      return total;
    }, 0);
  }, [data]);
  const AmountNameHeader = (props) => {
    return (
      <div
        onClick={(e) => {
          props.onClick(e);
        }}
        style={{ textAlign: "center", cursor: "pointer" }}>
        {props.title}
        {props.children}
      </div>
    );
  };

  const handleSelectAll = () => {
    setData((prevData) => {
      if (!prevData.length) return prevData;
      const allSelected = prevData.every((row) => row.add === true);
      if (allSelected) {
        return prevData.map((item) => ({ ...item, add: false, amount: 0.0 }));
      }
      return prevData.map((item) => ({
        ...item,
        add: true,
        amount: item.amountDue,
      }));
    });
  };

  const SelectAllHeader = (headerProps) => {
    const some = data.some((r) => r.add);
    const all = data.length > 0 && data.every((r) => r.add);
    const checked =
      data.length === 0 ? false : all ? true : some ? null : false;

    return (
      <div className="d-flex align-items-center justify-content-center text-center gap-1">
        <div
          onClick={(e) => headerProps.onClick(e)}
          className="k-link"
          style={{ cursor: "pointer" }}>
          {headerProps.title}
          {headerProps.children}
        </div>
        <Checkbox
          checked={checked}
          className="ms-2"
          aria-label="Select all rows"
          onChange={handleSelectAll}
        />
      </div>
    );
  };

  useEffect(() => {
    mergeAllocation();

    if (props.selectedData) {
      props.selectedData(data);
    }
  }, [data]);

  const itemChange = (e) => {
    let newData = data.map((item) => {
      if (item.postingId === e.dataItem.postingId) {
        if (
          e.field === "amount" &&
          e.value <= item.amountDue &&
          item.amountDue >= 0
        ) {
          item[e.field || ""] = e.value;
        } else if (
          e.field === "amount" &&
          e.value < 0 &&
          e.value > item.amountDue &&
          item.amountDue < 0
        ) {
          item[e.field || ""] = e.value;
        } else if (e.field === "add") {
          item[e.field || ""] = e.value;
        }
      }
      return item;
    });
    setData(newData);
    if (e.field === "amount") {
      if (
        e.dataItem.amount !== 0 &&
        e.dataItem.amount !== null &&
        e.dataItem.add === false
      ) {
        let newData = data.map((item) => {
          if (item.postingId === e.dataItem.postingId) {
            item.add = true;
          }
          return item;
        });
        setData(newData);
      } else if (
        (e.dataItem.amount === 0 || e.dataItem.amount === null) &&
        e.dataItem.add === true
      ) {
        let newData = data.map((item) => {
          if (item.postingId === e.dataItem.postingId) {
            item.add = false;
          }
          return item;
        });
        setData(newData);
      }
    }
    function getAmountToZero(sum) {
      return -sum;
    }
    if (e.field === "add") {
      if (e.dataItem.add === true) {
        let newData = data.map((item) => {
          if (item.postingId === e.dataItem.postingId) {
            const sum = data
              .filter((item) => item.add === true)
              .reduce((acc, item) => acc + item.amount, 0);

            let diff = sum - amount;

            if (amount === 0 || !amount) {
              diff = sum;
            }

            if (sum !== 0 || amount !== 0) {
              if (item.amountDue >= 0) {
                const allocatedAmount = Math.min(
                  getAmountToZero(diff),
                  item.amountDue
                );
                item.amount =
                  allocatedAmount >= 0 ? Math.abs(allocatedAmount) : item.amountDue;
              } else {
                const allocatedAmount = Math.max(
                  getAmountToZero(diff),
                  item.amountDue
                );
                item.amount = allocatedAmount < 0 ? allocatedAmount : item.amountDue;
              }
            } else {
              item.amount = item.amountDue;
            }
          }
          return item;
        });
        setData(newData);
      } else {
        let newData = data.map((item) => {
          if (item.postingId === e.dataItem.postingId) {
            item.amount = 0.0;
          }
          return item;
        });
        setData(newData);
      }
    }
  };

  return (
    <Grid
      style={props.style}
      data={process(data, dataState)}
      dataItemKey={"postingId"}
      onItemChange={itemChange}
      onDataStateChange={dataStateChange}
      pageable
      {...dataState}
      sortable
      editField="inEdit"
      className={
        props.className ||
        "accounts-table office-credit-grid flex-grow-1 overflow-auto"
      }>
      <Column
        field="date"
        title="Date"
        editable={false}
        headerClassName="ps-4"
        width="100px"
        cell={DateFormatCell}
      />
      <Column field="postingType" title="Type" editable={false} width="90px" />
      <Column field="reference" title="Reference" editable={false} width="100px" />
      <Column field="details" title="Details" editable={false} />
      <Column
        field="vatAmount"
        title="Vat"
        editable={false}
        cell={AmountFormatCell}
        headerCell={AmountNameHeader}
        width="100px"
      />
      <Column
        field="grossAmount"
        title="Gross Amount"
        editable={false}
        cell={AmountFormatCell}
        headerCell={AmountNameHeader}
        width="120px"
      />
      <Column
        field="amountPaid"
        title="Paid"
        editable={false}
        cell={AmountFormatCell}
        headerCell={AmountNameHeader}
        width="120px"
      />
      <Column
        field="amountDue"
        title="Due"
        editable={false}
        cell={AmountFormatCell}
        headerCell={AmountNameHeader}
        width="120px"
      />
      <Column
        field="add"
        title="Select"
        editor="boolean"
        className="text-center"
        width="80px"
        sortable={false}
        headerCell={SelectAllHeader}
      />
      <Column
        field="amount"
        title="Allocate"
        editor="numeric"
        cell={NumericCell}
        headerCell={AmountNameHeader}
        width="140px"
        footerCell={() => (
          <td style={{ textAlign: "center", fontWeight: "bold" }}>
            Total: {totalAllocatingAmount.toFixed(2)}
          </td>
        )}
      />
    </Grid>
  );
};
export default OfficeCreditGrid;
